import $ from 'jquery';
import Dialog from 'ui/dialog';
import 'style-loader!./flyout.css';

export default class Flyout extends Dialog {

  connectedCallback () {
    super.connectedCallback();
    this.dialog.prepend(this._createArrowUp());
    this.dialog.classList.add('d-flyout');
  }

  _createArrowUp () {
    const arrowUp = document.createElement('div');
    arrowUp.classList.add('arrow-up');
    return arrowUp;
  }

  show (target, at) {
    super.show();
    positionAtTarget(this.dialog, target, at);
  }

  showModal (target, at) {
    super.showModal();
    positionAtTarget(this.dialog, target, at);
  }

}

function positionAtTarget (dialog, target, at = 'bottom') {
  const my = invert(at);
  const of = target;

  const $arrow = $('.arrow-up', dialog);
  const arrowHeight = $arrow.outerHeight();
  const arrowWidth = $arrow.outerWidth();

  $(dialog).position({
    my,
    at,
    of,
    collision: 'fit',
    using: offset(offsetX(at, arrowHeight), offsetY(at, arrowHeight))
  });
  $arrow.css('transform', `rotate(${arrowRotate(at)})`).position({
    my,
    at,
    of,
    collision: 'none',
    using: offset(arrowOffsetX(at, arrowHeight), arrowOffsetY(at, arrowWidth / 4))
  });
}

function invert (at) {
  return ({
    'top': 'bottom',
    'right': 'left',
    'bottom': 'top',
    'left': 'right'
  })[at];
}

function offset (x, y) {
  return function ({top, left}) { $(this).css({ top: top + y, left: left + x }); };
}

function offsetX (at, offset) {
  if (at === 'left') return -offset;
  if (at === 'right') return offset;
  return 0;
}

function offsetY (at, offset) {
  if (at === 'top') return -offset;
  if (at === 'bottom') return offset;
  return 0;
}

function arrowOffsetX (at, offset) {
  return (at === 'left') ? offset : 0;
}

function arrowOffsetY (at, offset) {
  return (at === 'left' || at === 'right') ? -offset : 0;
}

function arrowRotate (at) {
  return ({
    'top': '180deg',
    'right': '270deg',
    'bottom': '0',
    'left': '90deg'
  })[at];
}

customElements.define('d-flyout', Flyout);
